<div class="checkout-headline">
  {{ "common.checkout_multi_secure_checkout" | cxTranslate }}
</div>
<ng-container>
  <mat-stepper orientation="vertical" [linear]="true" [selectedIndex]="userInWhichStep" #stepper
    (selectionChange)="selectionChange($event)">
    <mat-step [stepControl]="firstFormGroup" [completed]="steponeCompleted.value">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>
          <div>1.&nbsp;{{'common.checkout_multi_paymentType'| cxTranslate}}
            <img *ngIf="!steponeCompleted.value ; else edit" src="/icons/arrow-up-white.svg"
              style="width: 25px; float: right;">
            <ng-template #edit>
              <span (click)="setActiveStep(1)" class="float-right">{{'common.checkout_multi_paymentMethod_edit'|
                cxTranslate}}</span>
            </ng-template>
          </div>
        </ng-template>
        <div class="step-body">
          <div class="step-body-form">
            <div class="radiobuttons_paymentselection">
              <label class="control-label  kbclass" for="PurchaseOrderNumber">
                <strong class="f-16 text-uppercase">
                  {{'common.checkout_multi_purchaseOrderNumber_label_NA'|cxTranslate}}</strong></label><br>
              <input name="purchaseOrderNumber" class="text form-control" type="text"
                style="border-radius: 0px !important;" formControlName="firstCtrl">
              <div
                *ngIf="firstFormGroup.hasError && (firstFormGroup.dirty || firstFormGroup.touched) && firstFormGroup.invalid"
                class="error-message">
                {{'common.checkout_error_paymenttype_formentry_invalid'|cxTranslate}}
              </div>
              <div class="row mt-4">
                <div class="col-xs-12 col-sm-6 customer-id-block">
                  <p>
                    <strong class="f-16">
                      {{'common.order_history_customer_ID'|cxTranslate}}</strong>
                  </p>
                  <span
                    class="f-16">{{stepone?.b2bCustomer?.firstName}}&nbsp;{{stepone?.b2bCustomer?.lastName}}</span><br>
                  <span class="f-email">{{stepone?.b2bCustomer?.uid}}</span>
                  <br><br>
                  <span class="f-16">{{stepone?.currentB2BUnit?.addresses[0]?.sapCustomerID}}</span><br>
                  <span class="f-16">
                    {{stepone?.currentB2BUnit?.addresses[0]?.companyName}}</span><br>
                  <p class="f-16">{{stepone?.currentB2BUnit?.addresses[0]?.line1}}<br>
                    {{stepone?.currentB2BUnit?.addresses[0]?.postalCode}},&nbsp;{{stepone?.currentB2BUnit?.addresses[0]?.town}}<br>
                    <span
                      *ngIf="stepone?.currentB2BUnit?.addresses[0]?.region?.name && !stepone?.currentB2BUnit?.addresses[0]?.hide0270RegionFlag">{{stepone?.currentB2BUnit?.addresses[0]?.region?.name}}</span>
                    <br>{{stepone?.currentB2BUnit?.addresses[0]?.country?.name}}<br>
                  </p>
                </div>
                <div class="col-xs-12 col-sm-6 billing-address-block">
                  <p>
                    <strong class="f-16">
                      {{'common.order_history_billing_address'|cxTranslate}}</strong>
                  </p>
                  <ng-container *ngIf="stepone?.paymentAddress">
                    <p class="f-16">
                      {{stepone?.paymentAddress?.sapCustomerID}}<br>
                      <span class="checkout-address">
                        {{stepone?.paymentAddress?.companyName}}<br>
                        {{stepone?.paymentAddress?.line1}}<br>
                        {{stepone?.paymentAddress?.postalCode}},&nbsp;{{stepone?.paymentAddress?.town}}<br>
                        <span
                          *ngIf="stepone?.paymentAddress?.region?.name && !stepone?.paymentAddress?.hide0270RegionFlag">{{stepone?.paymentAddress?.region?.name}}<br></span>
                        {{stepone?.paymentAddress?.country?.name}}<br>
                        <br>
                      </span>
                    </p>
                  </ng-container>
                  <ng-container *ngIf="!stepone?.paymentAddress">
                    <p class="f-16">
                      {{stepone?.defaultBilling?.sapCustomerID}}<br>
                      {{stepone?.defaultBilling?.companyName}}<br>
                      {{stepone?.defaultBilling?.line1}}<br>
                      {{stepone?.defaultBilling?.postalCode}},&nbsp;{{stepone?.defaultBilling?.town}}<br>
                      <span
                        *ngIf="stepone?.defaultBilling?.region?.name && !stepone?.defaultBilling?.hide0270RegionFlag">{{stepone?.defaultBilling?.region?.name}}<br></span>
                      {{stepone?.defaultBilling?.country?.name}}<br>
                      <br>
                    </p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
     
        </div>
        <button class="btn  btn-block checkout-next" (click)="postStepOneData()">
          {{'common.checkout_pages_availabilty_final_review'|cxTranslate}}
          <img src="/icons/link-dark-grey.svg" style="width: 35px;" class="whiteArrow" alt="Link Icon">
        </button>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" [completed]="stepTwoCompleted.value">
      <form [formGroup]="secondFormGroup">
        <ng-template matStepLabel><span>2.&nbsp;{{ "common.checkout_multi_deliveryMethod" | cxTranslate }}
            <img *ngIf="!stepTwoCompleted.value; else edit" src="/icons/arrow-up-white.svg"
              style="width: 25px; float: right" />
            <ng-template #edit>
              <span (click)="setActiveStep(2)" class="float-right">{{
                "common.checkout_multi_paymentMethod_edit" | cxTranslate
                }}</span>
            </ng-template></span></ng-template>
        <div class="step-body">
          <div class="step-body-form">
            <div class="checkout-Outer row">
              <!-- OrderType -->
              <div class="checkout-shipping-order-type col-12 col-sm-12">
                <div class="checkout-order-type-title">
                  {{ "common.checkout_page_summary_order_type" | cxTranslate }}
                </div>
                <div class="checkout-order-type-description">
                  {{ stepTwo?.selectedOrderTypeName }}
                </div>
              </div>
              
              <div class="checkout-deliveryType col-12 col-sm-12" *ngIf="stepTwo?.['carriers'].length >=0">
                <label for="carrierType">
                  <span *ngIf="isSTOR()">{{
                    "common.checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA_STOR"
                    | cxTranslate
                    }}</span>
                  <span *ngIf="!isSTOR()">{{
                    "common.checkout_page_summary_deliveryMode_selectDeliveryMethodForOrder_NA"
                    | cxTranslate
                    }}</span>
                </label>
               
                <select id="carrierType" formControlName="carrierType" class="form-control" [(ngModel)]="carrierType">
                  <option value="null" selected>
                    {{ "common.please_select_state_text" | cxTranslate }}
                  </option>
                  <option *ngFor="let option of stepTwo?.['carriers']" [value]="option.code">
                    {{ option.name }}
                  </option>
                </select>
                <div class="carrier-selection-error"
                  *ngIf="(stepTwo?.['carriers'].length > 0) && (secondFormGroup.get('carrierType').invalid && secondFormGroup.get('carrierType').touched)&&(this.isEMGY() || this.isSHFD())">
                  {{ "common.select_a_carrier_error_emea" | cxTranslate }}
                </div>
              </div>
              <!-- carrier Selection Account Number-->
              <div class="checkout-deliveryType col-12 col-sm-12">
                <label for="carrierAccnumber">
                  {{ "common.choose_delivery_carrier_account_number"| cxTranslate }}
                </label>
                <input name="carrierAccnumber" class="text form-control carrierAccnumber" type="text"
                  style="border-radius: 0px !important" formControlName="carrierAccNumber" />
                <div class="carrier-selection-error carrier-AccNum-error" *ngIf="carrierAccFlag">
                  {{errorMessage}}
                </div>
              </div>
              <!-- OrderNotes -->
              <div class="checkout-comments col-12 col-sm-12">
                <label for="orderNotes" [style.white-space]="'pre-line'"
                  [innerHTML]="'common.checkout_page_DeliveryMethodForOrder_NA_orderNote'|cxTranslate"></label>
                <textarea id="orderNotes" rows="3" formControlName="orderNotes" class="form-control"
                  [(ngModel)]="orderNote"></textarea>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-block checkout-next" (click)="postStepTwoData()">
          {{ "common.checkout_pages_availabilty_final_review" | cxTranslate }}
          <img src="/icons/link-dark-grey.svg" style="width: 35px" class="whiteArrow" alt="Link Icon" />
        </button>
      </form>
    </mat-step>
    <mat-step [completed]="this.stepThreeCompleted.value">
      <ng-template matStepLabel>
        <div>
          3.&nbsp;<span class="step-title">{{
            "common.checkout_summary_shippingAddress" | cxTranslate
            }}</span>
          <img *ngIf="!stepThreeCompleted.value; else edit" src="/icons/arrow-up-white.svg"
            style="width: 25px; float: right" />
          <ng-template #edit>
            <span (click)="setActiveStep(3)" class="float-right">{{
              "common.checkout_multi_paymentMethod_edit" | cxTranslate
              }}</span>
          </ng-template>
        </div>
      </ng-template>
      <div class="step-body" *ngIf="thirdStep">
        <div class="step-body-form step-three">
          <!-- your code -->
          <div class="row">
            <div class="col-xs-12 col-sm-12 customer-id-block container">
              <span class="text-color">{{ "common.text_attn" | cxTranslate }}&nbsp;{{
                thirdStep.b2bCustomer.name
                }}
              </span>
              <p class="uid-text">{{ thirdStep.b2bCustomer.displayUid }}</p>
              <p class="text-color">
                <span>{{ thirdStep.deliveryAddress?.sapCustomerID }}</span><br />
                <span>{{ thirdStep.deliveryAddress?.companyName }}</span><br />
                <span>{{ thirdStep.deliveryAddress?.line1 }}</span><br />
                {{ thirdStep.deliveryAddress?.postalCode }}<span
                  *ngIf="thirdStep?.deliveryAddress?.town">,&nbsp;{{thirdStep?.deliveryAddress?.town}}</span><br>
                <span
                  *ngIf="thirdStep?.deliveryAddress?.region?.name && !thirdStep?.deliveryAddress?.hide0270RegionFlag">{{thirdStep?.deliveryAddress?.region?.name}}<br></span>
                <span>{{ thirdStep?.deliveryAddress?.country?.name }}</span>
              </p>
            </div>
          </div>
          <button *ngIf="thirdStep.isAddShippingAddress" type="button" class="btn  btn-block checkout-next fs-18"
            (click)="showAddAddress = !showAddAddress">
            {{
            "common.checkout_page_delivery_address_emergency" | cxTranslate
            }}
          </button>
          <button class="btn button-launch" type="button" *ngIf="
                thirdStep?.deliveryAddresses &&
                thirdStep?.deliveryAddresses?.length > 0
              " (click)="
                openDialog(thirdStep?.deliveryAddresses, thirdStep.code, false)
              ">
            {{
            "common.checkout_page_summary_change_shipping_address"
            | cxTranslate
            }}
          </button>
          <div class="address-form" *ngIf="showAddAddress">
            <form [formGroup]="thirdFormGroup">
              
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <label for="email" class="control-label">{{
                  "common.address_companyName" | cxTranslate
                  }}</label>
                <input type="text" class="form-control" formControlName="companyName" />
              </div>
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <label for="email" class="control-label">{{
                  "common.address_shipping_page_form_na" | cxTranslate
                  }}</label>
                <input type="text" class="form-control" formControlName="address" />
              </div>
              
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <label for="email" class="control-label">{{
                  "common.address_line2_shipping_page_form"
                  | cxTranslate
                  }}</label>
                <input type="text" class="form-control" formControlName="address2" />
              </div>
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <label for="email" class="control-label">{{
                  "common.address_city_shipping_page_form" | cxTranslate
                  }}</label>
                <input type="text" class="form-control" formControlName="city" />
              </div>

              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <ng-container>
                  <label for="country" class="control-label">{{
                    "common.address_regionIso_shipping_form" | cxTranslate
                    }}</label>
                  <div class="select-box">
                    <select name="country" class="form-control" formControlName="state">
                      <option value="null" disabled selected>
                        {{
                        "common.address_regionIso_shipping_form" | cxTranslate | uppercase
                        }}
                      </option>
                      <option *ngFor="let item of stateList" [value]="item.isocode">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>
              </div>

              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <label for="email" class="control-label">{{
                  "common.address_postalcode" | cxTranslate
                  }}</label>
                <input type="text" class="form-control" formControlName="postalCode" />
              </div>
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-0">
                <ng-container>
                  <label for="country" class="control-label">{{
                    "common.address_countryIso" | cxTranslate
                    }}</label>
                  <div class="select-box">
                    <select name="country" class="form-control" formControlName="country" (change)="getStateList()">
                      <option value="null" disabled selected>
                        {{
                        "common.address_countryIso" | cxTranslate | uppercase
                        }}
                      </option>
                      <option *ngFor="let item of thirdStep.supportedcountries" [value]="item.isocode">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </ng-container>
              </div>
              <div class="col-xs-12 col-sm-12 d-flex align-items-center btn-action">
                <button class="btn button-launch" type="button" (click)="showAddAddress = false">
                  {{ "common.checkout_multi_cancel" | cxTranslate }}
                </button>
                <button class="btn  btn-block checkout-next fs-18" type="button" (click)="saveAddress(thirdStep.code)">
                  {{ "common.checkout_multi_saveAddress" | cxTranslate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <button class="btn  btn-block checkout-next" type="submit" (click)="postStepThreeData(thirdStep.code)">
        {{ "common.checkout_multi_deliveryAddress_continue" | cxTranslate }}
        <img src="/icons/link-dark-grey.svg" style="width: 35px" class="whiteArrow" alt="Link Icon" />
      </button>
    </mat-step>
    <mat-step [stepControl]="fourthFormGroup">
      <ng-template matStepLabel>
        <div>
          4.&nbsp;<span class="step-title">{{
            "common.checkout_summary_reviewYourOrder" | cxTranslate
            }}</span>
          <img src="/icons/arrow-up-white.svg" style="width: 25px; float: right" alt="" />
        </div>
      </ng-template>
      <!-- step4 changes -->
      <div *ngIf="stepFourData" class="step-4 d-sm-block">
        <div class="row">
          <div class="col-xs-12 col-sm-6 customer-id-block">
            <span class="customer-id">{{
              "common.checkout_orderConfirmation_Customer_ID" | cxTranslate
              }}</span>
            <br />
            <p>
              <span class="text-color">{{ stepFourData.b2bCustomer.name }}</span><br />
              <span class="uid-text">{{ stepFourData.b2bCustomer.uid }}</span>
            </p>
            <br />
            <p class="text-color">
              <span>{{
                stepFourData.currentB2BUnit.addresses[0].sapCustomerID
                }}</span><br />
              <span>{{
                stepFourData.currentB2BUnit.addresses[0].companyName
                }}</span><br />
              <span>{{ stepFourData.currentB2BUnit.addresses[0].line1 }}</span><br />
              <span>{{ stepFourData.currentB2BUnit.addresses[0].postalCode }},&nbsp;{{
                stepFourData.currentB2BUnit.addresses[0].town }}</span><br />
              <span
                *ngIf="stepFourData?.currentB2BUnit?.addresses[0]?.region?.name && !stepFourData?.currentB2BUnit?.addresses[0]?.hide0270RegionFlag">{{stepFourData?.currentB2BUnit?.addresses[0]?.region?.name}}<br></span>
              <span>{{
                stepFourData.currentB2BUnit.addresses[0].country.name
                }}</span>
            </p>
          </div>
          <div class="col-xs-12 col-sm-6 customer-id-block">
            <span class="customer-id">{{'common.checkout_multi_purchaseOrderNumber_label_NA'|cxTranslate}}
            </span><br>
            <p><span class="text-color">{{stepFourData.purchaseOrderNumber}}</span>
            </p>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 customer-id-block">
            <span class="customer-id">{{
              "common.checkout_page_summary_final_review_billing_address"
              | cxTranslate
              }}</span>
            <br /><br />
            <p class="text-color">
              <span>{{ stepFourData.defaultBilling.sapCustomerID }}</span><br />
              <span>{{ stepFourData.defaultBilling.companyName }}</span><br />
              <span>{{ stepFourData.defaultBilling.line1 }}</span><br />
              <span>{{ stepFourData.defaultBilling.postalCode }},&nbsp;{{ stepFourData.defaultBilling.town
                }}</span><br />
              <span
                *ngIf="stepFourData?.defaultBilling?.region?.name && !stepFourData?.defaultBilling?.hide0270RegionFlag">{{stepFourData?.defaultBilling?.region?.name}}<br></span>
              <span>{{ stepFourData.defaultBilling.country.name }}</span>
            </p>
          </div>
          <div class="col-xs-12 col-sm-6 customer-id-block">
            <span class="customer-id">{{
              "common.checkout_summary_shippingAddress" | cxTranslate
              }}</span>
            <br /><br />
            <p class="text-color">
              <span>{{ stepFourData.deliveryAddress?.sapCustomerID }}</span><br />
              <span>{{ stepFourData.deliveryAddress?.companyName }}</span><br />
              <span>{{ stepFourData.deliveryAddress?.line1 }}</span><br />
              <span>{{ stepFourData.deliveryAddress?.postalCode }},&nbsp;{{ stepFourData.deliveryAddress?.town
                }}</span><br />
              <span
                *ngIf="stepFourData?.deliveryAddress?.region?.name && !stepFourData?.deliveryAddress?.hide0270RegionFlag">{{stepFourData?.deliveryAddress?.region?.name}}<br></span>
              <span>{{ stepFourData.deliveryAddress?.country?.name }}</span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 customer-id-block">
            <strong class="customer-id">
              {{ "common.checkout_orderConfirmation_order_Type" | cxTranslate }}
            </strong>
            &nbsp;
            <span class="text-color">{{ stepFourData.selectedOrderTypeName }}</span>
            <br>
            <strong class="customer-id">
              {{ "common.checkout_page_summary_final_review_carrierSelection" | cxTranslate }}
            </strong>
            &nbsp; <span class="text-color">{{ stepFourData?.currentCarrierType }}</span><br />

            <span *ngIf="stepFourData.currentCarrierNumber.trim()"
              class="customer-id">{{'common.choose_delivery_carrier_account_number'|cxTranslate}}:</span>
            &nbsp; <span class="text-color"
              *ngIf="stepFourData.currentCarrierNumber.trim()">{{stepFourData?.currentCarrierNumber}}</span><br />
            <span *ngIf="stepFourData.orderNote.trim()"
              class="customer-id">{{'common.checkout_orderConfirmation_order_note'|cxTranslate}}</span>
            &nbsp; <span class="text-color" *ngIf="stepFourData.orderNote">{{stepFourData.orderNote}}</span><br />

            <p class="emgywarn" *ngIf="stepFourData?.selectedOrderTypeCode=='EMGY'">
              <span>{{ "common.text_cutoff_timezone_NA" | cxTranslate }}</span>
            </p>
            <span *ngIf="timezoneMsg" class="emgywarn">{{timezoneMsg}}</span>
          </div>

        </div>
        <div class="row" *ngIf="showNetPrice$|async">
          <div class="d-flex col-xs-12 col-sm-12 customer-id-block price-column">
            <div class="col-xs-12 col-sm-6 pl">
              <div class="price-text" *ngIf="fleetPrideGroup">{{'common.order_totals_subtotal'|cxTranslate}}</div>
              <div class="price-text" *ngIf="stepFourData?.minOrderCharge?.value??0 >0">
                {{'common.text_account_order_min_NA'|cxTranslate}}</div>
            </div>
            <div *ngIf="showNetPrice$|async"
              class="col-xs-12 col-sm-6 d-flex align-items-end flex-column subtotal-price-block">
             
              <div class="price-text" *ngIf="stepFourData?.subTotal?.formattedValue.indexOf('-') > -1 ||
                stepFourData?.minOrderCharge?.formattedValue.indexOf('-') > -1  ||
                stepFourData.totalPrice?.formattedValue.indexOf('-') > -1;else showSubTotalPrice">
                {{ 'common.basket_page_poa' | cxTranslate }}
              </div>
              <ng-template #showSubTotalPrice>
                <div class="price-text">
                  {{stepFourData.subTotal?.formattedValue}}&nbsp;{{stepFourData.subTotal?.currencyIso}}
                </div>
              </ng-template>



              <div class="price-text" *ngIf="stepFourData?.minOrderCharge?.value??0 >0">
                <div class="price-text" *ngIf="stepFourData?.subTotal?.formattedValue.indexOf('-') > -1 ||
                stepFourData?.minOrderCharge?.formattedValue.indexOf('-') > -1 ||
                stepFourData.totalPrice?.formattedValue.indexOf('-') > -1 ;else showMinOrderSurchargePrice">
                  {{ 'common.basket_page_poa' | cxTranslate }}
                </div>
                <ng-template #showMinOrderSurchargePrice>
                  <div class="price-text">
                    {{stepFourData.minOrderCharge?.formattedValue}}&nbsp;{{stepFourData.minOrderCharge?.currencyIso}}
                  </div>
                </ng-template>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div *ngIf="showNetPrice$|async"
            class="d-flex total-section col-xs-12 col-sm-12 d-flex align-items-center justify-content-space-between total-price-block">
            <div *ngIf="fleetPrideGroup">
              <span class="total">{{ "common.basket_page_totals_total" | cxTranslate }}</span>
            </div>
            <div *ngIf="fleetPrideGroup">
             
              <span class="total" *ngIf="stepFourData?.subTotal?.formattedValue.indexOf('-') > -1 ||
                stepFourData?.minOrderCharge?.formattedValue.indexOf('-') > -1 ||
                stepFourData.totalPrice?.formattedValue.indexOf('-') > -1 ;else showTotalPrice">
                {{ 'common.basket_page_poa' | cxTranslate }}
              </span>
              <ng-template #showTotalPrice>
                <span class="total">{{ stepFourData.totalPrice?.formattedValue }} &nbsp;
                  {{ stepFourData.subTotal?.currencyIso }}</span>
              </ng-template>
            </div>
          </div>
          <div class="form-group col-xs-12 col-sm-12 place-order-btn-block">
            <div class="form-check dataProtection">
              <input [checked]="isTermsChecked" class="form-check-input" type="checkbox"
                (click)="placeOrderCheck($event)" />
              <label class="form-check-label uid-text">
                {{
                "common.checkout_summary_placeOrder_readTermsAndConditions"
                | cxTranslate
                }}
                <a (click)="openGeneralConditions()" style="cursor: pointer;">
                  {{"common.text_training_booking_form_terms_link" | cxTranslate}}</a>
              </label>
            </div>
            <button class="btn btn-block place-order" [disabled]="!canPlaceOrder"
              (click)="placeOrder(stepFourData.code)">
              {{ "common.checkout_summary_placeOrder" | cxTranslate }}
              <img src="/icons/link-dark-grey.svg" style="width: 35px" class="whiteArrow" alt="Link Icon" />
            </button>
          </div>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</ng-container>
<div class="col-xs-12 col-sm-12 d-none d-sm-none d-md-none d-lg-block" style="padding: 0">
  <button class="d-flex align-items-center back-to-cart" [routerLink]="{ cxRoute: 'cart' } | cxUrl">
    <img src="/icons/link_left-blue.svg" class="icon-right" alt="" />
    <span>{{ "common.checkout_page_back_to_cart" | cxTranslate }}</span>
  </button>
</div>